import { cloneElement } from 'react';
import { Accordion as MuiAccordion } from '@mui/material';
import accordionStyleBuilder from './accordionStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';

/** Wrapper component that expands to reveal content  */
import { jsx as _jsx } from "react/jsx-runtime";
export const Accordion = props => {
  const {
    children,
    className,
    contained = false,
    defaultExpanded = false,
    expanded,
    onChange = undefined,
    sx,
    id,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const style = mergeSxStyle(accordionStyleBuilder(theme, contained), sx);
  const _getChildren = () => {
    const _children = Array.isArray(children) ? children : [children];
    return _children.map((child, ind) => /*#__PURE__*/cloneElement(child, {
      key: 'Accordion' + ind.toString(),
      contained,
      ...child.props
    }));
  };
  const _handleChange = (event, isExpanded) => {
    if (onChange) {
      onChange();
    }
  };
  return /*#__PURE__*/_jsx(MuiAccordion, {
    id: id,
    "data-testid": rest['data-testid'],
    className: className,
    defaultExpanded: defaultExpanded,
    disableGutters: true,
    expanded: expanded,
    onChange: _handleChange,
    sx: style,
    square: !contained,
    slotProps: {
      transition: {
        timeout: {
          enter: 150,
          exit: 75
        },
        unmountOnExit: true,
        mountOnEnter: true
      }
    },
    children: _getChildren()
  });
};